// =========================================================
// frontend/js/booking.js - VERSION V16.9 (Lösch-Sperre & Vier-Augen-Prinzip)
// =========================================================
window.calculateBookingCO2Snapshot = function(user) {
    const c = user.commute || {};
    // Fallback: Wenn keine Distanz da ist, ist die Einsparung 0
    if (!c.distance || c.distance <= 0) return 0;
    // 1. Hole die globalen Faktoren, aber sichere JEDEN Wert einzeln ab!
    const factors = window.activeCO2Factors || {};
    const fPetrol = factors.petrol !== undefined ? factors.petrol : 0.165;
    const fDiesel = factors.diesel !== undefined ? factors.diesel : 0.150;
    const fElectro = factors.electro !== undefined ? factors.electro : 0.050;
    const fPublic = factors.public !== undefined ? factors.public : 0.030;
    const fHoElec = factors.ho_electricity !== undefined ? factors.ho_electricity : 0.35;
    const fHoHeat = factors.ho_heating !== undefined ? factors.ho_heating : 1.15;
    // 2. Faktor basierend auf dem Fahrzeugtyp des Users ermitteln
    let factor = fPetrol; // Fallback: Benzin
    if (c.type === 'diesel') factor = fDiesel;
    else if (c.type === 'public') factor = fPublic;
    else if (c.type === 'electro') factor = fElectro;
    else if (c.type === 'bike') factor = 0; // Fahrrad = 0 Emissionen
    // Falls der User eigene Emissionen in seinem Profil hinterlegt hat
    if (c.customEmissions && c.customEmissions > 0) factor = c.customEmissions / 1000;
    if (c.isCarpool) factor = factor / 2;
    // 3. Brutto Einsparung: (Einfache Strecke * 2) * Faktor
    const bruttoSavings = c.distance * 2 * factor;
    // 4. Homeoffice-Verbrauch berechnen (Strom + Heizung)
    const hoCosts = fHoElec + fHoHeat;
    // 5. Netto Einsparung = Eingesparter Arbeitsweg - Zusatzverbrauch im HO
    let nettoSavings = bruttoSavings - hoCosts;
    // Sicherheits-Check: Falls etwas schiefgeht oder das HO mehr verbraucht als Pendeln
    if (nettoSavings < 0 || isNaN(nettoSavings)) nettoSavings = 0;
    return parseFloat(nettoSavings.toFixed(3));
};
window.getEventStyle = function(typeId) {
    const u = window.currentUser;
    const overrides = u?.prefs?.colorOverrides || {};
    const userOverrideHex = overrides[typeId];
    const defaultTypes = {
        'HO': {
            color: 'blue',
            customHex: userOverrideHex || '#3b82f6',
            icon: 'home',
            name: 'Homeoffice'
        },
        'homeoffice': {
            color: 'blue',
            customHex: userOverrideHex || '#3b82f6',
            icon: 'home',
            name: 'Homeoffice'
        },
        'vacation': {
            color: 'emerald',
            customHex: userOverrideHex || '#10b981',
            icon: 'palmtree',
            name: 'Urlaub'
        },
        'urlaub': {
            color: 'emerald',
            customHex: userOverrideHex || '#10b981',
            icon: 'palmtree',
            name: 'Urlaub'
        },
        'sick': {
            color: 'rose',
            customHex: userOverrideHex || '#f43f5e',
            icon: 'stethoscope',
            name: 'Krankheit'
        },
        'krank': {
            color: 'rose',
            customHex: userOverrideHex || '#f43f5e',
            icon: 'stethoscope',
            name: 'Krankheit'
        },
        'admin_event': {
            color: 'orange',
            customHex: userOverrideHex || '#f97316',
            icon: 'globe',
            name: 'Globales Ereignis'
        }
    };
    if (defaultTypes[typeId]) return defaultTypes[typeId];
    const companyType = (window.statusTypes || []).find((t)=>t.id === typeId);
    if (companyType) return {
        color: 'slate',
        customHex: userOverrideHex || companyType.color,
        icon: companyType.icon || 'star',
        name: companyType.name
    };
    if (u && u.customStatusTypes) {
        const userType = u.customStatusTypes.find((t)=>t.id === typeId);
        if (userType) return {
            color: 'slate',
            customHex: userType.color || '#8b5cf6',
            icon: userType.icon || 'user',
            name: userType.name
        };
    }
    return {
        color: 'slate',
        customHex: userOverrideHex || '#94a3b8',
        icon: 'calendar',
        name: typeId || 'Eintrag'
    };
};
window.bookingTempData = {};
window.saveTempDataFromDOM = function() {
    const start = document.getElementById('book-date-start');
    const end = document.getElementById('book-date-end');
    const comment = document.getElementById('book-comment');
    const vis = document.getElementById('book-visibility');
    if (start) window.bookingTempData.start = start.value;
    if (end) window.bookingTempData.end = end.value;
    if (comment) window.bookingTempData.comment = comment.value.trim();
    if (vis) window.bookingTempData.visibility = vis.value;
};
// Prüft, ob ein Feiertag vorliegt. Wenn ja, gibt das Event-Objekt des Feiertags zurück
window.getHolidayAtDate = function(dateStr, userNodeId) {
    return (window.events || []).find((e)=>{
        if (e.type !== 'admin_event' || e.status === 'REJECTED') return false;
        if (e.date !== dateStr) return false;
        const isGlobalType = (window.statusTypes || []).find((t)=>t.id === e.subType);
        if (isGlobalType && isGlobalType.name.toLowerCase().includes('feiertag')) {
            if (e.isGlobal) return true;
            if (e.targetNodeIds && e.targetNodeIds.includes(userNodeId)) return true;
        }
        return false;
    });
};
window.openBookingModal = function(dateStr, existingEventId = null) {
    const u = window.currentUser;
    let existingEvent = existingEventId ? (window.events || []).find((e)=>e.id === existingEventId) : null;
    window.bookingTempData = {
        start: dateStr,
        end: dateStr,
        comment: existingEvent ? existingEvent.comment : '',
        visibility: existingEvent ? existingEvent.visibility : 'public',
        existingEventId: existingEventId
    };
    const modalHTML = `
        <div id="booking-modal" class="fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-[200] flex items-center justify-center p-4 animate-fadeIn">
            <div class="bg-white rounded-[2.5rem] shadow-2xl w-full max-w-sm overflow-hidden flex flex-col max-h-[95vh]">
                <div id="booking-modal-header" class="p-6 border-b border-slate-100 flex items-center justify-between bg-slate-50/50 shrink-0">
                    <h3 class="text-sm font-black text-slate-800 uppercase tracking-widest">${existingEventId ? 'Eintrag verwalten' : 'Eintrag planen'}</h3>
                    <button onclick="document.getElementById('booking-modal').remove()" class="w-8 h-8 flex items-center justify-center bg-white rounded-full border border-slate-200 text-slate-400 hover:text-slate-800 shadow-sm transition-colors"><i data-lucide="x" class="w-4 h-4"></i></button>
                </div>
                <div id="booking-modal-body" class="p-0 overflow-y-auto no-scrollbar flex-1"></div>
            </div>
        </div>
    `;
    document.body.insertAdjacentHTML('beforeend', modalHTML);
    window.renderMainBookingState();
};
window.toggleWeekdaySelector = function() {
    const start = document.getElementById('book-date-start')?.value;
    const end = document.getElementById('book-date-end')?.value;
    const container = document.getElementById('weekday-selector-container');
    if (container) container.classList.toggle('hidden', !(end && start !== end));
};
window.renderMainBookingState = function() {
    const u = window.currentUser;
    const tmp = window.bookingTempData;
    const existingEvent = tmp.existingEventId ? (window.events || []).find((e)=>e.id === tmp.existingEventId) : null;
    const [y, m, d] = tmp.start.split('-').map(Number);
    const targetDate = new Date(y, m - 1, d, 12, 0, 0);
    const currentWk = typeof getWeekNumber === 'function' ? getWeekNumber(targetDate) : 0;
    const monthPrefix = `${y}-${String(m).padStart(2, '0')}`;
    const wUsed = (window.events || []).filter((e)=>e.userId === u.uid && e.status !== 'REJECTED' && (e.type === 'HO' || e.type === 'homeoffice') && (typeof getWeekNumber === 'function' ? getWeekNumber(new Date(e.date)) : -1) === currentWk).length;
    const mUsed = (window.events || []).filter((e)=>e.userId === u.uid && e.status !== 'REJECTED' && (e.type === 'HO' || e.type === 'homeoffice') && e.date.startsWith(monthPrefix)).length;
    const wLimit = u?.limits?.weekly?.days || 99;
    const mLimit = u?.limits?.monthly?.days || 99;
    // ==========================================
    // 🔥 FIX: Wir nutzen "isStrict" aus der member.js
    // ==========================================
    const wIsStrict = u?.limits?.weekly?.isStrict === true || (u?.limits?.weekly?.ruleType || '').toLowerCase() === 'hard';
    const mIsStrict = u?.limits?.monthly?.isStrict === true || (u?.limits?.monthly?.ruleType || '').toLowerCase() === 'hard';
    // Check, ob ein Limit erreicht wurde UND es sich um eine strikte/harte Regel handelt
    const wLimitHard = u?.limits?.weekly?.hasLimit && wUsed >= wLimit && wIsStrict;
    const mLimitHard = u?.limits?.monthly?.hasLimit && mUsed >= mLimit && mIsStrict;
    const isHOHardLimitReached = wLimitHard || mLimitHard;
    // ==========================================
    const personalCustomStatuses = (u?.customStatusTypes || []).filter((st)=>st.isActive !== false);
    const isOwner = u?.role === 'OWNER';
    const canManageGlobal = isOwner || window.hasPermission && (window.hasPermission('calendar_edit_global') || window.hasPermission('manage_global_events'));
    const isGlobalEvent = existingEvent && existingEvent.type === 'admin_event';
    if (isGlobalEvent && !canManageGlobal) {
        const style = typeof window.getEventStyle === 'function' && existingEvent.subType ? window.getEventStyle(existingEvent.subType) : {
            customHex: '#f97316',
            icon: 'globe'
        };
        const bodyHtml = `
            <div class="p-8 text-center animate-fadeIn">
                <div class="w-24 h-24 border-4 border-white shadow-xl rounded-[2rem] flex items-center justify-center mx-auto mb-6" style="background-color: ${style.customHex}15; color: ${style.customHex}">
                    <i data-lucide="${style.icon}" class="w-10 h-10"></i>
                </div>
                <h3 class="text-2xl font-black text-slate-800 mb-2">${existingEvent.typeName}</h3>
                <p class="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-8">Globales Unternehmens-Ereignis</p>
                <div class="bg-slate-50 border border-slate-100 p-6 rounded-3xl text-left shadow-inner">
                    <p class="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-1">Datum</p>
                    <p class="font-bold text-slate-700 text-sm mb-4">${new Date(existingEvent.date).toLocaleDateString('de-DE', {
            weekday: 'long',
            day: 'numeric',
            month: 'long',
            year: 'numeric'
        })}</p>
                    ${existingEvent.comment ? `<p class="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-1 pt-4 border-t border-slate-200">Notiz</p><p class="font-bold text-slate-700 text-sm italic">${existingEvent.comment}</p>` : ''}
                </div>
                <div class="mt-8 flex flex-col gap-3">
                    <p class="text-[9px] font-black text-slate-300 uppercase tracking-widest flex items-center justify-center gap-1.5"><i data-lucide="lock" class="w-3 h-3"></i> Schreibschutz aktiv</p>
                    <button onclick="document.getElementById('booking-modal').remove()" class="w-full bg-slate-100 text-slate-600 py-4 rounded-2xl font-black uppercase text-[10px] tracking-widest hover:bg-slate-200 transition-all shadow-sm">Verstanden</button>
                </div>
            </div>`;
        document.getElementById('booking-modal-body').innerHTML = bodyHtml;
        if (window.lucide) lucide.createIcons();
        return;
    }
    let isSeries = existingEvent && existingEvent.seriesId;
    let seriesInfoHtml = '';
    if (isSeries) {
        const sEvents = (window.events || []).filter((e)=>e.seriesId === existingEvent.seriesId).sort((a, b)=>a.date.localeCompare(b.date));
        if (sEvents.length > 1) {
            const firstDate = new Date(sEvents[0].date).toLocaleDateString('de-DE');
            const lastDate = new Date(sEvents[sEvents.length - 1].date).toLocaleDateString('de-DE');
            seriesInfoHtml = `
                <div class="bg-blue-50 border border-blue-100 p-4 rounded-2xl mb-6 flex items-start gap-4">
                    <div class="p-2 bg-blue-100 text-blue-600 rounded-xl shrink-0"><i data-lucide="layers" class="w-5 h-5"></i></div>
                    <div><p class="text-[10px] font-black text-blue-600 uppercase tracking-widest mb-1">Serientermin (${sEvents.length} Tage)</p><p class="text-xs text-blue-800 font-bold">${firstDate} - ${lastDate}</p></div>
                </div>`;
        }
    }
    const isHoliday = !existingEvent && window.getHolidayAtDate(tmp.start, u.nodeId);
    let holidayWarningHtml = '';
    if (isHoliday) holidayWarningHtml = `
            <div class="bg-orange-50 border border-orange-200 p-4 rounded-2xl mb-4 flex items-center gap-3">
                <i data-lucide="calendar-off" class="w-5 h-5 text-orange-600 shrink-0"></i>
                <p class="text-xs font-bold text-orange-800">Feiertag erkannt. Wenn du eine Serie buchst, werden Feiertage automatisch \xfcbersprungen und nicht als Urlaub gebucht.</p>
            </div>`;
    const dayConfig = [
        {
            d: 1,
            n: 'Mo'
        },
        {
            d: 2,
            n: 'Di'
        },
        {
            d: 3,
            n: 'Mi'
        },
        {
            d: 4,
            n: 'Do'
        },
        {
            d: 5,
            n: 'Fr'
        },
        {
            d: 6,
            n: 'Sa'
        },
        {
            d: 0,
            n: 'So'
        }
    ];
    const daysHtml = dayConfig.map((day)=>`
        <label class="cursor-pointer flex-1 text-center">
            <input type="checkbox" value="${day.d}" class="book-day-cb hidden" ${u?.defaultWorkdays?.includes(day.d) ? 'checked' : ''} onchange="this.nextElementSibling.classList.toggle('bg-blue-500'); this.nextElementSibling.classList.toggle('text-white');">
            <div class="w-full h-8 rounded-lg text-[10px] font-black flex items-center justify-center transition-all border ${u?.defaultWorkdays?.includes(day.d) ? 'bg-blue-500 text-white border-blue-500' : 'bg-slate-50 text-slate-400 border-slate-200'}">${day.n}</div>
        </label>`).join('');
    const showWeekdaysInitial = tmp.end && tmp.start !== tmp.end;
    // Das Approval Formular wird NUR noch getriggert, wenn ein HARTES Limit gerissen wurde
    const hoOnClick = isHOHardLimitReached && !existingEvent ? `window.showHOApprovalForm()` : `window.submitPersonalBooking('HO', 'Homeoffice')`;
    // =========================================================
    // 🔒 LÖSCH-SPERRE FÜR VERGANGENHEITS-EINTRÄGE (Vier-Augen-Prinzip)
    // =========================================================
    let canDelete = true;
    let deleteWarningMsg = '';
    if (existingEvent) {
        // Welcher Typ ist es?
        const type = (existingEvent.type || '').toLowerCase();
        const protectedTypes = [
            'vacation',
            'urlaub',
            'sick',
            'krankheit',
            'krank',
            'ho',
            'homeoffice'
        ];
        // Prüfe, ob das Event-Datum VOR heute liegt
        const eventDateObj = new Date(existingEvent.date);
        const todayObj = new Date();
        todayObj.setHours(0, 0, 0, 0); // Uhrzeit ignorieren
        const isInPast = eventDateObj < todayObj;
        const isProtectedType = protectedTypes.includes(type);
        // Sperren, wenn in der Vergangenheit UND geschützt
        if (isInPast && isProtectedType) {
            canDelete = false; // Erstmal pauschal für alle sperren
            if (type === 'ho' || type === 'homeoffice') deleteWarningMsg = "Vergangene Homeoffice-Tage sind f\xfcr den CO\u2082-Report fixiert und k\xf6nnen nur durch HR storniert werden.";
            else deleteWarningMsg = "Abgeschlossene Eintr\xe4ge k\xf6nnen nur noch von der Personalabteilung (HR) storniert werden.";
            // ---------------------------------------------------------
            // 4. AUSNAHMEN & VIER-AUGEN-PRINZIP
            // ---------------------------------------------------------
            const isMyOwnEvent = existingEvent.userId === u.uid;
            const isOwnerOrSuper = [
                'OWNER',
                'SUPERADMIN'
            ].includes(u.role);
            const hasHRPermission = [
                'HR',
                'ADMIN'
            ].includes(u.role) || u.extraPermissions && (u.extraPermissions.includes('hr_admin') || u.extraPermissions.includes('manage_users'));
            if (isOwnerOrSuper) // Der Geschäftsführer (OWNER) darf alles, auch bei sich selbst
            canDelete = true;
            else if (hasHRPermission) {
                if (isMyOwnEvent) // HR will eigenen Eintrag löschen -> BLEIBT GESPERRT!
                deleteWarningMsg = "Vier-Augen-Prinzip: Du kannst deine eigenen vergangenen Eintr\xe4ge nicht selbst stornieren. Bitte wende dich an einen anderen Admin oder Vorgesetzten.";
                else // HR löscht Eintrag von jemand anderem -> ERLAUBT!
                canDelete = true;
            }
        }
    }
    // =========================================================
    const bodyHtml = `
        <div class="p-6 animate-fadeIn">
            ${seriesInfoHtml}
            ${holidayWarningHtml}
            <div class="space-y-6">
                <div class="border border-slate-200 rounded-2xl p-4 bg-slate-50/50">
                    <div class="flex gap-4">
                        <div class="flex-1">
                            <label class="text-[9px] font-black text-slate-400 uppercase tracking-widest mb-1.5 block">Von</label>
                            <input type="date" id="book-date-start" onchange="window.toggleWeekdaySelector()" value="${tmp.start}" class="w-full bg-white border border-slate-200 rounded-xl px-3 py-2 text-xs font-bold text-slate-700 outline-none" ${existingEvent ? 'readonly' : ''}>
                        </div>
                        ${!existingEvent ? `
                        <div class="flex-1">
                            <label class="text-[9px] font-black text-slate-400 uppercase tracking-widest mb-1.5 block">Bis (Optional)</label>
                            <input type="date" id="book-date-end" onchange="window.toggleWeekdaySelector()" value="${tmp.end || ''}" class="w-full bg-white border border-slate-200 rounded-xl px-3 py-2 text-xs font-bold text-slate-700 outline-none">
                        </div>` : ''}
                    </div>
                    ${!existingEvent ? `
                    <div id="weekday-selector-container" class="mt-4 pt-4 border-t border-slate-100 ${showWeekdaysInitial ? '' : 'hidden'} transition-all">
                        <label class="text-[9px] font-black text-slate-400 uppercase tracking-widest mb-2 block">Wochentage</label>
                        <div class="flex gap-1 w-full">${daysHtml}</div>
                    </div>` : ''}
                </div>
                <input type="text" id="book-comment" placeholder="Notiz (optional)..." value="${tmp.comment}" class="w-full bg-slate-50 border border-slate-200 rounded-2xl px-4 py-4 text-xs font-medium text-slate-700 focus:border-blue-400 outline-none transition-all">
                <div id="booking-action-container" class="grid grid-cols-1 gap-2 relative">
                    
                    ${!existingEvent ? `
                    <button onclick="${hoOnClick}" class="w-full flex items-center justify-between p-3 bg-white border border-slate-200 rounded-2xl hover:border-blue-400 transition-all group shadow-sm">
                        <div class="flex items-center gap-3"><div class="w-8 h-8 rounded-xl bg-blue-100 text-blue-600 flex items-center justify-center"><i data-lucide="home" class="w-4 h-4"></i></div><span class="text-sm font-bold text-slate-700">Homeoffice</span></div>
                        <i data-lucide="chevron-right" class="w-4 h-4 text-slate-300 group-hover:text-blue-500"></i>
                    </button>
                    
                    <button onclick="window.submitPersonalBooking('vacation', 'Urlaub')" class="w-full flex items-center justify-between p-3 bg-white border border-slate-200 rounded-2xl hover:border-emerald-400 group transition-all shadow-sm">
                        <div class="flex items-center gap-3"><div class="w-8 h-8 rounded-xl bg-emerald-100 text-emerald-600 flex items-center justify-center"><i data-lucide="palmtree" class="w-4 h-4"></i></div><span class="text-sm font-bold text-slate-700">Urlaub</span></div>
                        <i data-lucide="chevron-right" class="w-4 h-4 text-slate-300 group-hover:text-emerald-500"></i>
                    </button>
                    
                    <button onclick="window.submitPersonalBooking('sick', 'Krankheit')" class="w-full flex items-center justify-between p-3 bg-white border border-slate-200 rounded-2xl hover:border-rose-400 transition-all group shadow-sm">
                        <div class="flex items-center gap-3"><div class="w-8 h-8 rounded-xl bg-rose-100 text-rose-600 flex items-center justify-center"><i data-lucide="stethoscope" class="w-4 h-4"></i></div><span class="text-sm font-bold text-slate-700">Krankheit</span></div>
                        <i data-lucide="chevron-right" class="w-4 h-4 text-slate-300 group-hover:text-rose-500"></i>
                    </button>
                    ${personalCustomStatuses.map((st)=>`
                        <button onclick="window.submitPersonalBooking('${st.id}', '${st.name}', true)" class="w-full flex items-center justify-between p-3 bg-white border border-slate-200 rounded-2xl hover:border-purple-400 transition-all group shadow-sm">
                            <div class="flex items-center gap-3"><div class="w-8 h-8 rounded-xl flex items-center justify-center text-white" style="background-color: ${st.color || '#a855f7'}"><i data-lucide="${st.icon || 'user'}" class="w-4 h-4"></i></div><span class="text-sm font-bold text-slate-700">${st.name}</span></div>
                            <i data-lucide="chevron-right" class="w-4 h-4 text-slate-300 group-hover:text-purple-500"></i>
                        </button>`).join('')}
                    ` : ''}

                </div>
                
                ${canManageGlobal && !existingEvent ? `<button onclick="window.goToGlobalTypeState()" class="w-full p-4 bg-orange-50 border border-orange-200 text-orange-600 rounded-2xl font-black uppercase text-[10px] tracking-widest hover:bg-orange-500 hover:text-white transition-all">Globale Ereignisse</button>` : ''}
                
                ${existingEvent ? `
                    ${canDelete ? `
                        <button onclick="window.initiateDelete('${tmp.existingEventId}', ${!!isSeries})" class="w-full mt-4 py-4 bg-rose-50 text-rose-600 rounded-2xl font-black uppercase text-[10px] tracking-widest hover:bg-rose-600 hover:text-white transition-all">Eintrag l\xf6schen</button>
                    ` : `
                        <div class="mt-4 p-4 bg-slate-100 rounded-2xl text-center border border-slate-200">
                            <p class="text-[10px] font-black text-slate-400 uppercase tracking-widest flex items-center justify-center gap-1.5"><i data-lucide="lock" class="w-3 h-3"></i> L\xf6schen gesperrt</p>
                            <p class="text-[10px] font-bold text-slate-500 mt-2">${deleteWarningMsg}</p>
                        </div>
                    `}
                ` : ''}

            </div>
        </div>`;
    document.getElementById('booking-modal-body').innerHTML = bodyHtml;
    if (window.lucide) lucide.createIcons();
};
window.showHOApprovalForm = function() {
    const container = document.getElementById('booking-action-container');
    if (!container) return;
    container.innerHTML = `
        <div class="bg-amber-50 border border-amber-200 p-5 rounded-2xl shadow-sm animate-fadeIn">
            <div class="flex items-center gap-2 mb-2">
                <i data-lucide="alert-triangle" class="w-4 h-4 text-amber-600"></i>
                <h4 class="font-black text-amber-800 uppercase tracking-widest text-[10px]">Homeoffice-Limit erreicht</h4>
            </div>
            <p class="text-[10px] text-amber-700 font-medium mb-4 leading-relaxed">Deine regul\xe4ren Homeoffice-Tage sind aufgebraucht. Bitte begr\xfcnde den Ausnahmeantrag f\xfcr deinen Vorgesetzten.</p>
            <textarea id="ho-approval-reason" rows="3" placeholder="Begr\xfcndung (mind. 5 Zeichen)..." class="w-full bg-white border border-amber-300 ring-2 ring-amber-100 rounded-xl px-3 py-3 text-xs font-medium text-slate-700 focus:border-amber-500 outline-none mb-3"></textarea>
            <div class="flex gap-2">
                <button onclick="window.renderMainBookingState()" class="flex-1 bg-white border border-slate-200 text-slate-500 py-3 rounded-xl font-black text-[10px] uppercase tracking-widest hover:bg-slate-50 transition-all shadow-sm">Abbrechen</button>
                <button onclick="window.submitHOApproval()" class="flex-1 bg-amber-500 text-white py-3 rounded-xl font-black text-[10px] uppercase tracking-widest hover:bg-amber-600 transition-all shadow-md">Einreichen</button>
            </div>
        </div>
    `;
    if (window.lucide) lucide.createIcons();
};
window.submitHOApproval = function() {
    const reason = document.getElementById('ho-approval-reason').value.trim();
    if (reason.length < 5) return alert("Bitte gib eine ausf\xfchrlichere Begr\xfcndung ein (mind. 5 Zeichen).");
    const mainComment = document.getElementById('book-comment');
    if (mainComment) mainComment.value = reason;
    window.submitPersonalBooking('HO', 'Homeoffice');
};
window.checkStaffingRule = function(dateStr, typeId, userId, userNodeId) {
    if (typeId !== 'HO' && typeId !== 'homeoffice' && typeId !== 'vacation' && typeId !== 'sick') return {
        ok: true
    };
    if (!userNodeId || userNodeId === 'unknown') return {
        ok: true
    };
    let targetNode = null;
    const findNode = (nodes)=>{
        for (let n of nodes){
            if (n.id === userNodeId) targetNode = n;
            if (n.children) findNode(n.children);
        }
    };
    findNode(window.orgStructure || []);
    if (!targetNode || !targetNode.minStaffing || !targetNode.minStaffing.enabled) return {
        ok: true
    };
    const teamMembers = (window.usersList || []).filter((u)=>u.nodeId === userNodeId);
    const totalTeamSize = teamMembers.length;
    const absentees = (window.events || []).filter((e)=>{
        if (e.date !== dateStr || e.status === 'REJECTED') return false;
        if (e.userId === userId) return false;
        if (!teamMembers.find((tm)=>tm.uid === e.userId)) return false;
        const t = (e.type || '').toLowerCase();
        return t === 'ho' || t === 'homeoffice' || t === 'vacation' || t === 'sick';
    });
    const remainingStaff = totalTeamSize - (absentees.length + 1);
    if (remainingStaff < targetNode.minStaffing.count) return {
        ok: false,
        type: targetNode.minStaffing.type || 'soft',
        required: targetNode.minStaffing.count,
        remaining: remainingStaff
    };
    return {
        ok: true
    };
};
window.submitPersonalBooking = async function(rawTypeId, typeName, isUserCustom = false) {
    window.saveTempDataFromDOM();
    const tmp = window.bookingTempData;
    const u = window.currentUser;
    const cid = u?.companyId;
    if (!cid) return;
    const typeId = rawTypeId === 'homeoffice' ? 'HO' : rawTypeId;
    const isHO = typeId === 'HO';
    const isVacation = typeId === 'vacation' || typeId === 'urlaub';
    const impact = isHO ? window.calculateImpact(u.commute, 1) : null;
    let finalStatus = 'APPROVED';
    let staffingWarningFlag = false;
    // 1. STAFFING RULE CHECK
    const staffingStatus = window.checkStaffingRule(tmp.start, typeId, u.uid, u.nodeId);
    if (!staffingStatus.ok) {
        if (staffingStatus.type === 'hard') return alert(`Mindestbesetzung unterschritten!\n\nDein Team erfordert min. ${staffingStatus.required} anwesende Personen. Nach deiner Buchung w\xe4ren nur noch ${staffingStatus.remaining} da.\n\nDiese Buchung ist durch eine harte Regel blockiert.`);
        else staffingWarningFlag = true;
    }
    // 2. DATUMSBERECHNUNG (Zuerst ermitteln, wie viele Tage gebucht werden!)
    const selectedDayEls = document.querySelectorAll('.book-day-cb:checked');
    const selectedDays = Array.from(selectedDayEls).map((cb)=>parseInt(cb.value));
    let datesToBook = [];
    let skippedHolidays = 0;
    let [startY, startM, startD] = tmp.start.split('-').map(Number);
    let curr = new Date(startY, startM - 1, startD, 12, 0, 0);
    let [endY, endM, endD] = (tmp.end || tmp.start).split('-').map(Number);
    let end = new Date(endY, endM - 1, endD, 12, 0, 0);
    const isSingleDay = tmp.start === (tmp.end || tmp.start);
    while(curr <= end){
        if (isSingleDay || selectedDays.includes(curr.getDay())) {
            const ds = curr.toISOString().split('T')[0];
            if (window.getHolidayAtDate(ds, u.nodeId)) skippedHolidays++;
            else datesToBook.push({
                date: ds
            });
        }
        curr.setDate(curr.getDate() + 1);
    }
    if (datesToBook.length === 0) return alert("Keine g\xfcltigen Tage gew\xe4hlt oder alle Tage sind Feiertage.");
    const requestedDaysCount = datesToBook.length; // Anzahl der NEU angefragten Tage
    // 3. LIMIT CHECK (Gilt jetzt für ALLE User, unabhängig von der Rolle)
    let isHOHardLimitException = false;
    // (Wir behalten die Variable isHOSoftLimitException für interne Logik, falls wir sie später noch für ein Warn-Popup brauchen)
    let isHOSoftLimitException = false;
    if (isHO) {
        const [y, m, d] = tmp.start.split('-').map(Number);
        const targetDate = new Date(y, m - 1, d, 12, 0, 0);
        const wIsStrict = u?.limits?.weekly?.isStrict === true || (u?.limits?.weekly?.ruleType || '').toLowerCase() === 'hard';
        const mIsStrict = u?.limits?.monthly?.isStrict === true || (u?.limits?.monthly?.ruleType || '').toLowerCase() === 'hard';
        if (u?.limits?.weekly?.hasLimit) {
            const wLimit = u.limits.weekly.days;
            const currentWk = getWeekNumber(targetDate);
            const wUsed = (window.events || []).filter((e)=>{
                if (e.userId !== u.uid || e.status === 'REJECTED') return false;
                if (e.type !== 'HO' && e.type !== 'homeoffice') return false;
                const evDate = new Date(e.date);
                return getWeekNumber(evDate) === currentWk && evDate.getFullYear() === y;
            }).length;
            // Wenn bisher gebuchte Tage + NEUE Tage das Limit überschreiten
            if (wUsed + requestedDaysCount > wLimit) {
                if (wIsStrict) isHOHardLimitException = true;
                else isHOSoftLimitException = true;
            }
        }
        if (u?.limits?.monthly?.hasLimit) {
            const mLimit = u.limits.monthly.days;
            const monthPrefix = `${y}-${String(m).padStart(2, '0')}`;
            const mUsed = (window.events || []).filter((e)=>{
                if (e.userId !== u.uid || e.status === 'REJECTED') return false;
                if (e.type !== 'HO' && e.type !== 'homeoffice') return false;
                return e.date.startsWith(monthPrefix);
            }).length;
            // Wenn bisher gebuchte Tage im Monat + NEUE Tage das Limit überschreiten
            if (mUsed + requestedDaysCount > mLimit) {
                if (mIsStrict) isHOHardLimitException = true;
                else isHOSoftLimitException = true;
            }
        }
    }
    // 4. STATUS FESTLEGEN
    if (isHOHardLimitException) {
        if (!tmp.comment || tmp.comment.trim().length < 5) return alert("Homeoffice-Limit erreicht: Bitte gib im Textfeld einen ausf\xfchrlicheren Grund f\xfcr diesen Ausnahmeantrag an.");
        finalStatus = 'PENDING'; // Es wird zum Antrag!
    }
    if (isVacation) {
        const vacRule = (u?.limits?.vacation?.type || 'none').toLowerCase();
        if (vacRule === 'hard' || vacRule === 'hart') finalStatus = 'PENDING';
        else if (vacRule === 'soft' || vacRule === 'weich') staffingWarningFlag = true;
    }
    // 5. IN FIREBASE SPEICHERN
    try {
        const batch = db.batch();
        const seriesId = requestedDaysCount > 1 ? 'series_' + Date.now() : null;
        for (const item of datesToBook){
            const newRef = db.collection('companies').doc(cid).collection('events').doc();
            batch.set(newRef, {
                userId: u.uid,
                userName: `${u.firstName} ${u.lastName}`,
                nodeId: u.nodeId || 'unknown',
                reportsTo: u.reportsTo || null,
                date: item.date,
                type: typeId,
                typeName: typeName,
                status: finalStatus,
                visibility: tmp.visibility || 'public',
                comment: tmp.comment || '',
                staffingWarning: staffingWarningFlag,
                seriesId: seriesId,
                companyId: cid,
                createdAt: Date.now(),
                co2SavedAtBooking: impact ? parseFloat(impact.co2Netto) : 0,
                moneySavedAtBooking: impact ? parseFloat(impact.money) : 0,
                timeSavedAtBooking: impact ? parseFloat(impact.time) : 0,
                commuteSnapshot: u.commute ? {
                    ...u.commute
                } : null
            });
        }
        await batch.commit();
        document.getElementById('booking-modal').remove();
        if (skippedHolidays > 0 && window.showToast) window.showToast(`${skippedHolidays} Feiertag(e) \xfcbersprungen.`);
        if (typeof window.syncGlobalImpact === 'function') {
            console.log("\uD83D\uDD04 Starte Exakten Daten-Sync nach Buchung...");
            await window.syncGlobalImpact();
        }
        if (typeof loadInitialData === 'function') await loadInitialData();
        window.render();
    } catch (e) {
        alert("Fehler: " + e.message);
    }
};
window.goToGlobalTypeState = function() {
    window.saveTempDataFromDOM();
    const activeCompanyStatuses = (window.statusTypes || []).filter((st)=>st.isActive);
    const bodyHtml = `
        <div class="p-6 animate-fadeIn space-y-4">
            <button onclick="window.renderMainBookingState()" class="text-[10px] font-black uppercase tracking-widest text-slate-400 hover:text-orange-500 flex items-center gap-2 transition-colors mb-6">
                <i data-lucide="arrow-left" class="w-3 h-3"></i> Zur\xfcck zur \xdcbersicht
            </button>
            <h4 class="text-[10px] font-black text-orange-500 uppercase tracking-widest mb-3 ml-1">Schritt 1: Art des Ereignisses</h4>
            <div class="grid grid-cols-1 gap-2">
                ${activeCompanyStatuses.map((type)=>`
                    <button onclick="window.goToGlobalScopeState('${type.id}', '${type.name}')" class="w-full flex items-center justify-between p-4 bg-white border border-orange-100 rounded-2xl hover:border-orange-400 hover:bg-orange-50 transition-all group shadow-sm">
                        <div class="flex items-center gap-4">
                            <div class="w-10 h-10 rounded-xl flex items-center justify-center text-white shadow-sm" style="background-color: ${type.color || '#f97316'}">
                                <i data-lucide="${type.icon || 'star'}" class="w-5 h-5"></i>
                            </div>
                            <span class="text-sm font-black text-slate-700">${type.name}</span>
                        </div>
                        <i data-lucide="arrow-right" class="w-4 h-4 text-orange-300 group-hover:text-orange-600 transition-colors"></i>
                    </button>
                `).join('')}
            </div>
        </div>`;
    document.getElementById('booking-modal-body').innerHTML = bodyHtml;
    if (window.lucide) lucide.createIcons();
};
window.goToGlobalScopeState = function(typeId, typeName) {
    const flatTree = typeof window.getFlattenedTree === 'function' ? window.getFlattenedTree(window.orgStructure || []) : [];
    const bodyHtml = `
        <div class="p-6 animate-fadeIn flex flex-col h-full">
            <button onclick="window.goToGlobalTypeState()" class="text-[10px] font-black uppercase tracking-widest text-slate-400 hover:text-orange-500 flex items-center gap-2 transition-colors mb-6">
                <i data-lucide="arrow-left" class="w-3 h-3"></i> Andere Art w\xe4hlen
            </button>
            <h4 class="text-[10px] font-black text-orange-500 uppercase tracking-widest mb-3 ml-1">Schritt 2: Zielgruppe f\xfcr "${typeName}"</h4>
            <div class="space-y-3 p-4 bg-orange-50/50 border border-orange-100 rounded-[2rem] flex-1">
                <label class="flex items-center justify-between p-4 bg-white border-2 border-orange-200 rounded-2xl cursor-pointer hover:border-orange-400 shadow-sm transition-all">
                    <span class="font-black text-sm text-slate-800">\u{1F30D} Gesamtes Unternehmen</span>
                    <input type="checkbox" id="global-scope-all" onchange="window.toggleAllScopes(this)" class="w-5 h-5 text-orange-600 rounded focus:ring-orange-500">
                </label>
                <div class="border-t border-orange-100 pt-3 space-y-2 transition-opacity" id="global-scope-list">
                    <p class="text-[9px] font-black text-slate-400 uppercase tracking-widest ml-1 mb-3">Oder gezielt Standorte/Abteilungen w\xe4hlen:</p>
                    ${flatTree.map((n)=>`
                        <label class="flex items-center justify-between p-3 bg-white border border-slate-100 rounded-xl cursor-pointer hover:border-orange-300 shadow-sm transition-all">
                            <span class="font-bold text-xs text-slate-600">\u{1F4CD} ${n.name}</span>
                            <input type="checkbox" value="${n.id}" class="scope-cb w-4 h-4 text-orange-500 rounded focus:ring-orange-500">
                        </label>
                    `).join('')}
                </div>
            </div>
            <button onclick="window.submitMultiGlobalEvent('${typeId}', '${typeName}')" class="w-full mt-6 bg-orange-500 text-white py-4 rounded-2xl font-black text-xs uppercase tracking-widest hover:bg-orange-600 transition-all shadow-xl shadow-orange-200 flex justify-center items-center gap-2">
                <i data-lucide="check-circle" class="w-4 h-4"></i> Ereignis eintragen
            </button>
        </div>`;
    document.getElementById('booking-modal-body').innerHTML = bodyHtml;
    if (window.lucide) lucide.createIcons();
};
window.toggleAllScopes = function(cb) {
    const list = document.getElementById('global-scope-list');
    if (cb.checked) {
        list.classList.add('opacity-40', 'pointer-events-none', 'grayscale');
        document.querySelectorAll('.scope-cb').forEach((c)=>c.checked = false);
    } else list.classList.remove('opacity-40', 'pointer-events-none', 'grayscale');
};
window.submitMultiGlobalEvent = async function(typeId, typeName) {
    const isAll = document.getElementById('global-scope-all').checked;
    const selectedCbs = Array.from(document.querySelectorAll('.scope-cb:checked')).map((cb)=>cb.value);
    if (!isAll && selectedCbs.length === 0) return alert("Bitte w\xe4hle mindestens eine Zielgruppe (Abteilung/Standort) aus.");
    const targetNodeIds = isAll ? [] : selectedCbs;
    const tmp = window.bookingTempData;
    const u = window.currentUser;
    const cid = u?.companyId;
    if (!cid) return;
    const globalConf = (window.statusTypes || []).find((st)=>st.id === typeId);
    const isMandatory = globalConf ? globalConf.isMandatory : false;
    const selectedDayEls = document.querySelectorAll('.book-day-cb:checked');
    const selectedDays = Array.from(selectedDayEls).map((cb)=>parseInt(cb.value));
    let dates = [];
    let curr = new Date(tmp.start);
    let end = new Date(tmp.end || tmp.start);
    const isSingleDay = tmp.start === (tmp.end || tmp.start);
    while(curr <= end){
        if (isSingleDay || selectedDays.includes(curr.getDay())) dates.push(curr.toISOString().split('T')[0]);
        curr.setDate(curr.getDate() + 1);
    }
    if (dates.length === 0) return alert("Bitte w\xe4hle mindestens einen Wochentag aus, der in diesem Zeitraum liegt.");
    const seriesId = dates.length > 1 ? 'series_' + Date.now() + Math.random().toString(36).substring(2, 6) : null;
    try {
        const batch = db.batch();
        for (const d of dates){
            const newRef = db.collection('companies').doc(cid).collection('events').doc();
            batch.set(newRef, {
                userId: u.uid,
                userName: `ADMIN: ${typeName}`,
                date: d,
                type: 'admin_event',
                subType: typeId,
                typeName: typeName,
                isGlobal: isAll,
                targetNodeIds: targetNodeIds,
                visibility: 'public',
                blocksWorking: true,
                status: 'APPROVED',
                isMandatory: isMandatory,
                seriesId: seriesId,
                companyId: cid,
                comment: tmp.comment,
                createdAt: Date.now()
            });
        }
        await batch.commit();
        document.getElementById('booking-modal').remove();
        if (window.showToast) window.showToast("Globales Ereignis gespeichert!");
        if (typeof loadInitialData === 'function') await loadInitialData();
    } catch (e) {
        alert(e.message);
    }
};
window.initiateDelete = function(eventId, isSeries) {
    if (!isSeries) {
        window.handleDelete(eventId, false);
        return;
    }
    const container = document.getElementById('booking-action-container');
    if (!container) return;
    container.innerHTML = `
        <div class="bg-rose-50 border border-rose-200 p-5 rounded-2xl shadow-sm animate-fadeIn mt-4">
            <h4 class="font-black text-rose-800 uppercase tracking-widest text-[10px] mb-2"><i data-lucide="alert-circle" class="w-3 h-3 inline mr-1"></i> Serien-Element l\xf6schen</h4>
            <p class="text-[10px] text-rose-700 font-medium mb-4">Dieser Eintrag ist Teil einer Buchungs-Serie. M\xf6chtest du nur diesen einen Tag oder die gesamte Serie entfernen?</p>
            
            <div class="flex flex-col gap-2">
                <button onclick="window.handleDelete('${eventId}', false)" class="w-full bg-white border border-rose-200 text-rose-600 py-3 rounded-xl font-black text-[10px] uppercase tracking-widest hover:bg-rose-100 transition-all shadow-sm">Nur diesen Tag l\xf6schen</button>
                <button onclick="window.handleDelete('${eventId}', true)" class="w-full bg-rose-600 text-white py-3 rounded-xl font-black text-[10px] uppercase tracking-widest hover:bg-black transition-all shadow-md">Gesamte Serie l\xf6schen</button>
                <button onclick="window.renderMainBookingState()" class="w-full mt-2 text-slate-400 py-2 rounded-xl font-black text-[10px] uppercase tracking-widest hover:text-slate-600 transition-all">Abbrechen</button>
            </div>
        </div>
    `;
    if (window.lucide) lucide.createIcons();
};
window.handleDelete = async function(eventId, deleteWholeSeries = false) {
    const u = window.currentUser;
    if (!u || !u.companyId) return;
    try {
        const docRef = db.collection('companies').doc(u.companyId).collection('events').doc(eventId);
        const docSnap = await docRef.get();
        if (!docSnap.exists) return;
        const ev = docSnap.data();
        // =========================================================
        // 🔒 HARDCORE-SICHERHEITS-CHECK VOR DEM ECHTEN LÖSCHEN
        // Verhindert das Löschen über die Browser-Konsole!
        // =========================================================
        const type = (ev.type || '').toLowerCase();
        const protectedTypes = [
            'vacation',
            'urlaub',
            'sick',
            'krankheit',
            'krank',
            'ho',
            'homeoffice'
        ];
        const eventDateObj = new Date(ev.date);
        const todayObj = new Date();
        todayObj.setHours(0, 0, 0, 0);
        if (eventDateObj < todayObj && protectedTypes.includes(type)) {
            const isMyOwnEvent = ev.userId === u.uid;
            const isOwnerOrSuper = [
                'OWNER',
                'SUPERADMIN'
            ].includes(u.role);
            const hasHRPermission = [
                'HR',
                'ADMIN'
            ].includes(u.role) || u.extraPermissions && (u.extraPermissions.includes('hr_admin') || u.extraPermissions.includes('manage_users'));
            if (!isOwnerOrSuper) // Wenn nicht HR, ODER wenn HR aber eigener Eintrag -> ABBRUCH!
            {
                if (!hasHRPermission || hasHRPermission && isMyOwnEvent) {
                    alert("Sicherheits-Sperre: Dieser vergangene Eintrag ist durch das System gesch\xfctzt und kann nicht gel\xf6scht werden.");
                    document.getElementById('booking-modal')?.remove();
                    return; // ⛔️ Bricht die Funktion hier sofort ab!
                }
            }
        }
        // =========================================================
        if (!deleteWholeSeries && !confirm("Diesen Eintrag wirklich l\xf6schen?")) return;
        if (deleteWholeSeries && ev.seriesId) {
            const seriesSnapshot = await db.collection('companies').doc(u.companyId).collection('events').where('seriesId', '==', ev.seriesId).where('userId', '==', ev.userId).get();
            const batch = db.batch();
            seriesSnapshot.forEach((doc)=>batch.delete(doc.ref));
            await batch.commit();
        } else await docRef.delete();
        document.getElementById('booking-modal')?.remove();
        if (typeof window.syncGlobalImpact === 'function') {
            console.log("\uD83D\uDD04 Starte Exakten Daten-Sync nach L\xf6schung...");
            await window.syncGlobalImpact();
        }
        if (typeof loadInitialData === 'function') await loadInitialData();
        window.render();
    } catch (e) {
        console.error(e);
    }
};

//# sourceMappingURL=frontend.aa744409.js.map
